import permissions from '../../permissions'

const EXPORT_INFO_LIST = [
  {
    name: 'Permitir/Negar acesso ao menu',
    tag: permissions.RIPD.EXPORT,
  },
]

export default EXPORT_INFO_LIST
